<template>
    <div>
        <b-card-code
                title="Megtekintés"
        >
            <b-overlay
                    :show="loading"
                    spinner-variant="primary"
                    spinner-type="grow"
                    rounded="sm"
            >
                <!-- form -->
                <validation-observer ref="simpleRules">
                    <b-form>
                        <b-row>
                            <b-col md="12">
                                <b-form-group
                                        label="HORINFO azonosító"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="HORINFO azonosító"
                                            rules="required"
                                            vid="horInfoId"
                                    >
                                        <b-form-input
                                                v-model="formData.horInfoId"
                                                :state="errors.length > 0 ? false:null"
                                                placeholder="HORINFO azonosító"
                                                readonly
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="12">
                                <b-form-group
                                        label="Név"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="név"
                                            rules="required"
                                            vid="name"
                                    >
                                        <b-form-input
                                                v-model="formData.name"
                                                :state="errors.length > 0 ? false:null"
                                                placeholder="név"
                                                readonly
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="12">
                                <b-form-group
                                        label="Víztérkód"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="víztérkód"
                                            rules="required"
                                            vid="waterCode"
                                    >
                                        <b-form-input
                                                v-model="formData.waterCode"
                                                :state="errors.length > 0 ? false:null"
                                                placeholder="víztérkód"
                                                readonly
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="12">
                                <b-form-group
                                        label="Aktív"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="aktív"
                                            rules="required"
                                            vid="active"
                                    >
                                        <b-form-input
                                                v-model="formData.active"
                                                :state="errors.length > 0 ? false:null"
                                                placeholder="aktív"
                                                readonly
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <!-- submit button -->
                            <b-col class="mt-1">
                                <cancel-and-g-o-t-o-previous-page class="mr-2"/>
                            </b-col>
                        </b-row>
                    </b-form>
                </validation-observer>
            </b-overlay>
        </b-card-code>
        <b-card-code>
            <tabs
                    ref="tabs"
                    :entity-id="parseInt(this.$route.params.id)"
            />
        </b-card-code>
    </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
    BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormCheckbox, BOverlay,
} from 'bootstrap-vue'
import {
    required,
} from '@validations'
import tabs from '@/views/pages/_components/_tabs/_water/update.vue'
import cancelAndGOTOPreviousPage from '@/views/pages/_components/_helper/cancelAndGOTOPreviousPage'

export default {
    components: {
        BCardCode,
        ValidationProvider,
        ValidationObserver,
        BFormInput,
        BFormGroup,
        BForm,
        BRow,
        BCol,
        BButton,
        BFormCheckbox,
        BOverlay,
        tabs,
        cancelAndGOTOPreviousPage,
    },
    data() {
        return {
            role: 'water',
            loading: false,
            formData: {
                id: null,
                name: '',
                waterCode: '',
                status: '',
                horInfoId: ''
            },
            required,
        }
    },
    created() {
        this.loading = true

        this.$store.dispatch('fetchWater', this.$route.params.id).then(response => {
            this.formData = response.data.entity
            this.formData.id = this.$route.params.id
            this.formData.waterCode = response.data.entity.water_code
            this.formData.name = response.data.entity.name
            this.formData.active = response.data.entity.active ? 'Igen' : 'Nem'
            this.formData.horInfoId = response.data.entity.horinfo_id ?? '-'
        }).finally(() => {
            this.loading = false
        })
    },
}
</script>
